<template>
  <form-item-wrapper class="vform" :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div class="mo-input--number">
      <el-input-number ref="fieldEditor" v-model="fieldModel" v-show="!isReadMode" class="full-width-input"
        :disabled="field.options.disabled" :size="field.options.size" :controls-position="field.options.controlsPosition"
        :placeholder="field.options.placeholder" :min="field.options.min" :max="field.options.max"
        :precision="field.options.precision" :step="field.options.step" @focus="handleFocusCustomEvent"
        @blur="handleBlurCustomEvent" @change="handleChangeEvent" :style="myStyles">
      </el-input-number>
      <div class="define-append" v-if="field.options.unit">{{field.options.unit}}</div>
    </div>
    <template v-if="isReadMode">
      <span class="readonly-mode-field">{{ fieldModel }}</span>
    </template>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from './form-item-wrapper'
import emitter from '@/utils/emitter'
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";

export default {
  name: "number-widget",
  componentName: 'FieldWidget',  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false
    },

    subFormRowIndex: { /* 子表单组件行索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormColIndex: { /* 子表单组件列索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormRowId: { /* 子表单组件行Id，唯一id且不可变 */
      type: String,
      default: ''
    },

  },
  components: {
    FormItemWrapper,
  },
  inject: ['refList', 'globalOptionData', 'globalModel'],
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: null,
      rules: [],
    }
  },
  computed: {
    myStyles() {
      return {
        'font-size': this.getFormConfig().fontSize + '!important',
        'font-weight': this.getFormConfig().fontWeight + '!important'
      }
    },

  },
  beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
       需要在父组件created中初始化！！ */
    this.registerToRefList()
    this.initFieldModel()
    this.initEventHandler()
    this.buildFieldRules()

    this.handleOnCreated()
  },

  mounted() {
    this.handleOnMounted()
  },

  beforeDestroy() {
    this.unregisterFromRefList()
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/global.scss"; //* form-item-wrapper已引入，还需要重复引入吗？ *//

.full-width-input {
  width: 100% !important;
}
/* 自定义数字输入框append  */
.mo-input--number {
    border: 1px solid #DCDFE6;
    width: 100%;
    display: flex;
    // border-radius: 2px;
    .el-input-number--mini{
      flex: 1;
    }
    ::v-deep .el-input__inner{
      border: none!important;
    }
  }
 
  .define-append{
    min-width: 34px;
    display: inline-block;
    background: #F5F7FA;
    padding: 0px 3px;
    color: #909399;
    font-size: 12px;
    text-align: center;
    border-left: 1px solid #DCDFE6;
    // border-radius: 0 4px 4px 0;
  }
  .el-input-number--medium{
    // width: 100%;
    flex: 1;
  }
  .el-input__inner{
    // border-radius: 4px 0 0 4px;
  }
</style>
